import React from 'react';
import { Input, Select, Icon, Row, Col, TreeSelect } from 'antd';

import SelectPlaceHolder from '../../../components/SelectPlaceHolder';

class Filters extends React.Component {

    onLoadData = treeNode =>
        new Promise(resolve => {
            const { id } = treeNode.props;
            setTimeout(() => {
                this.props.onData(id)
                resolve();
            }, 100);
        });



    render() {
        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    <Col className="gutter-row" sm={24} md={12} lg={6}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.nombre} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("nombre", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por nombre"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.codigoReferencia} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("codigoReferencia", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Código de referencia"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.codigoBarra} //STATE PROPERTY
                            onChange={(e) => this.props.onChange("codigoBarra", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Código de barra"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idUnidadMedida ?
                                    { key: this.props.filter.idUnidadMedida } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Unidad de medida" />}
                            onChange={(option) => this.props.onChange("idUnidadMedida", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.unidadesMedida.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.codigoSunat + ' - ' + item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idMarca ?
                                    { key: this.props.filter.idMarca } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Marca" />}
                            onChange={(option) => this.props.onChange("idMarca", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.marcas.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idModelo ?
                                    { key: this.props.filter.idModelo } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Modelo" />}
                            onChange={(option) => this.props.onChange("idModelo", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.modelos.map(item => (
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.estado ?
                                    { key: this.props.filter.estado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Estado" />}
                            onChange={(option) => this.props.onChange("estado", option.key)}
                            optionFilterProp="children"
                        >
                            {this.props.estados.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={5}>
                        <TreeSelect
                            treeDataSimpleMode
                            style={{ width: '100%' }}
                            value={this.props.filter.idCategoria == 0 ? undefined : this.props.filter.idCategoria}
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder="Categoria"
                            onChange={(value) => this.props.onChange("idCategoria", value)}
                            loadData={this.onLoadData}
                            treeData={this.props.segmentoCategoria}
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Filters;